import { Routes } from '@angular/router';
import { benefitsRoutes } from './benefits/benefits.routes';
import { developersRoutes } from './developers/developers.routes';
import { projectsRoutes } from './projects/projects.routes';

export const dashboardRoutes: Routes = [
  {
    children: benefitsRoutes,
    path: 'benefits',
  },
  {
    children: developersRoutes,
    path: 'developers',
  },
  {
    children: projectsRoutes,
    path: 'projects',
  },
  {
    path: '**',
    redirectTo: 'developers',
  },
];
